import PropTypes from 'prop-types';
import React from 'react';

export class Email extends React.Component {
  renderEmail() {
    if (this.props.email) {
      return <span><a href={'mailto:' + this.props.email} {...this.props.otherProperties}>{this.props.email}</a></span>;
    }

    return null;
  }

  render() {
    return this.renderEmail();
  }
}

Email.propTypes = {
  email: PropTypes.string,
  otherProperties: PropTypes.object,
};